import m from "./../../../dist/es2015/themes/Frozen.js";
export const am5themes_Frozen = m;